import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon, { SOURCES } from 'components/Icon';

const ToolbarIcon = ({ name, options, className }) => {
  const icon = {
    source: null,
    iconName: name,
  };

  if (name.startsWith(SOURCES.LIZZY)) {
    icon.source = SOURCES.LIZZY;
    icon.name = name;
  } else if (name.startsWith(SOURCES.MATERIAL)) {
    icon.source = SOURCES.MATERIAL;
    icon.name = name.replace(`${SOURCES.MATERIAL}-`, '');
  }

  return (
    <Icon
      className={className}
      source={icon.source}
      name={icon.name}
      options={options}
    />
  );
}

export default styled(ToolbarIcon)``;

ToolbarIcon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  options: PropTypes.shape(PropTypes.any),
}